import type { ExtendedFieldSpec } from '@wix/wix-data-client-common'
import type { Schema } from '@wix/wix-data-schema-types'

export const createCollectionFields = (
  fields: Schema['fields'],
): ExtendedFieldSpec[] =>
  Object.entries(fields).map(([name, fieldDefinitions]) => ({
    ...fieldDefinitions,
    name,
  }))
